// Archiviom — scripts propios (vanilla, sin librerías externas)

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function mtInitContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      var dur = 1400;
      var t0 = null;
      function paso(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var val = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = (fin % 1 === 0) ? Math.round(val) : val.toFixed(1);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function mtInitGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
        mini.classList.add('mt-mini-activa');
      });
    });
  });
}

function mtInitVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = wrap.querySelectorAll('[data-mt-opcion]');
    var idInput = wrap.querySelector('input[name="id"]');
    var precioEl = wrap.querySelector('[data-mt-precio]');
    var precioComparadoEl = wrap.querySelector('[data-mt-precio-comparado]');
    var botonEl = wrap.querySelector('[data-mt-comprar]');
    var textoBoton = botonEl ? botonEl.getAttribute('data-mt-texto-comprar') || 'Añadir al carrito' : '';
    var textoAgotado = botonEl ? botonEl.getAttribute('data-mt-texto-agotado') || 'Agotado' : '';

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function actualizar() {
      if (!selects.length) return;
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (precioComparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparadoEl.textContent = formatearDinero(variante.compare_at_price);
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.disabled = false;
          botonEl.textContent = textoBoton;
        } else {
          botonEl.disabled = true;
          botonEl.textContent = textoAgotado;
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function mtInitMarquesina() {
  document.querySelectorAll('[data-mt-marquesina]').forEach(function (m) {
    var track = m.querySelector('.mt-marquee-track');
    if (!track || track.dataset.mtCloned) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtCloned = '1';
  });
}

function mtInitAntesDespues() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
    var handle = comp.querySelector('[data-mt-comparador-asa]');
    var despues = comp.querySelector('[data-mt-comparador-despues]');
    if (!handle || !despues) return;
    var activo = false;
    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      despues.style.width = pct + '%';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function (e) { activo = true; handle.setPointerCapture(e.pointerId); });
    handle.addEventListener('pointerup', function () { activo = false; });
    handle.addEventListener('pointermove', function (e) { if (activo) mover(e.clientX); });
    comp.addEventListener('click', function (e) { mover(e.clientX); });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitContadores();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitMarquesina();
  mtInitAntesDespues();
});
